import React, { PropsWithChildren, useState } from 'react';

import { Reservation } from '../../graphql/API';

export type ChatContextProps = {
  shouldChatOpen: boolean;
  offerId: string;
  reservation: Reservation | null;
  setShouldChatOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setOfferId: React.Dispatch<React.SetStateAction<string>>;
  setReservation: React.Dispatch<React.SetStateAction<Reservation | null>>;
};

export const ChatContext = React.createContext<ChatContextProps | null>(null);

export const ChatProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [shouldChatOpen, setShouldChatOpen] = useState(false);
  const [offerId, setOfferId] = useState('');
  const [reservation, setReservation] = useState<Reservation | null>(null);

  return (
    <ChatContext.Provider
      value={{
        shouldChatOpen,
        setShouldChatOpen,
        offerId,
        setOfferId,
        reservation,
        setReservation,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};
